type Props = React.SVGProps<SVGSVGElement> & {
  size?: number;
  className?: string;
};

export function MaterialContractIcon(props: Props) {
  const size = props.size ?? 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.5"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.75 14.667c-.486 0-.9-.17-1.24-.51-.34-.341-.51-.754-.51-1.24v-1.25c0-.275.098-.51.294-.707A.963.963 0 0 1 3 10.667h1V2.333c0-.275.098-.51.294-.706A.963.963 0 0 1 5 1.333h8c.275 0 .51.098.706.294a.963.963 0 0 1 .294.706v10.584c0 .486-.17.899-.51 1.24-.34.34-.754.51-1.24.51h-8.5Zm8.498-1c.213 0 .39-.072.535-.216s.217-.322.217-.534V2.333H5v8.334h5.5c.275 0 .51.098.706.293a.963.963 0 0 1 .294.707v1.25c0 .212.072.39.215.534a.723.723 0 0 0 .534.216ZM6.5 5.333a.482.482 0 0 1-.356-.144A.488.488 0 0 1 6 4.83a.487.487 0 0 1 .5-.497h5c.142 0 .26.049.356.145a.488.488 0 0 1 .144.358.488.488 0 0 1-.5.497h-5Zm0 2a.482.482 0 0 1-.356-.144A.488.488 0 0 1 6 6.83a.487.487 0 0 1 .5-.497h5c.142 0 .26.049.356.145a.488.488 0 0 1 .144.358.488.488 0 0 1-.5.497h-5Zm-2.767 6.334H10.5v-2H3v1.25c0 .212.072.39.217.534a.707.707 0 0 0 .516.216Zm0 0H3h7.5Z"
      />
    </svg>
  );
}
